export { useSplashScreenContext, SplashScreenProvider } from './splashscreen'
